import {HOTEL_TYPE} from '@/models-hotel';

const hotelType: HOTEL_TYPE = 'A';
export const hotelName = '디아넥스';
export default hotelType;
